export const CODE_FIELD_HEIGHT: number = 500
